import { Exercise } from "@/Components/Exercises/exerciseSchema";
import { createContext } from "react";

export type UnseenExerciseState = "new" | "updated";

export const initialExercisePickerContext = {
    unseenExercises: {} as Record<
        Exercise["id"],
        {
            state: UnseenExerciseState;
        }
    >,
    setSeen: async (_exerciseId: Exercise["id"]) => {},
    unseenExercisesTotal: 0,
};

export const ExercisesSeenContext = createContext(initialExercisePickerContext);
